import React, { useState } from 'react';
import { Form, Input, Select, Row, Col, Button, message } from 'antd';
import { sitesService } from '../../services/api';

const { Option } = Select;

const StepSite = ({
    form,
    sitesExistentes,
    selectedSite,
    onSiteChange,
    onCepChange,
    onNumeroChange,
    currentStep,
    totalSteps,
    onPrev,
    onNext,
    onSave,
    empresaClienteId,
}) => {
    const [loading, setLoading] = useState(false);
    const [siteSalvo, setSiteSalvo] = useState(false);
    const token = localStorage.getItem('token');

    const handleSave = async () => {
        try {
            setLoading(true);
            await form.validateFields();
            const values = form.getFieldsValue();

            const statusMap = { Conectado: 'ATIVO', Desconectado: 'INATIVO' };
            const payload = {
                name: values.nome,
                address: `${values.rua || ''}, ${values.numero || ''} - ${values.bairro || ''}`.trim(),
                city: values.cidade,
                state: values.estado,
                zipCode: values.cep,
                status: statusMap[values.status] || values.status || 'ATIVO',
                pessoaResponsavel: values.pessoaResponsavel || null,
                emailResponsavel: values.emailResponsavel || null,
                cnpjResponsavel: values.cnpjResponsavel?.trim() || null,
                latitude: values.latitude ? parseFloat(values.latitude) : null,
                longitude: values.longitude ? parseFloat(values.longitude) : null,
                empresaClienteId: values.empresaClienteId || empresaClienteId || null,
            };

            const response = await sitesService.create(payload);
            const site = response?.data;
            if (site?.id) {
                message.success('Site salvo com sucesso!');
                setSiteSalvo(true);
                onSave({ ...payload, id: site.id });
            }
        } catch (error) {
            message.error(error.response?.data?.message || 'Erro ao salvar o site.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', backgroundColor: 'white' }}>
            <Form layout="vertical" form={form}>
                <h2 style={{ color: '#2957A4', marginBottom: 16 }}>Site</h2>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Selecione Site Existente">
                            <Select
                                placeholder="Escolha um site existente"
                                value={selectedSite}
                                onChange={onSiteChange}
                                allowClear
                            >
                                {sitesExistentes?.map((site) => (
                                    <Option key={site.id} value={site.id}>
                                        {site.name || site.nome}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <h2 style={{ color: '#2957A4', marginBottom: 16 }}>Endereço do Site</h2>

                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Nome do Site" name="nome" rules={[{ required: true, message: 'Informe o nome!' }]}>
                            <Input placeholder="Nome do Projeto" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="CNPJ do Responsável" name="cnpjResponsavel">
                            <Input placeholder="00.000.000/0001-00" maxLength={18} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Nome do Responsável" name="pessoaResponsavel">
                            <Input placeholder="Nome da pessoa responsável" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="CEP" name="cep" rules={[{ required: true, message: 'Informe o CEP!' }]}>
                            <Input
                                placeholder="00000-000"
                                onChange={(e) => {
                                    const val = e.target.value;
                                    onCepChange?.(val);
                                    // Foca no campo Número após o CEP ser preenchido (8 dígitos)
                                    if (val.replace(/\D/g, '').length >= 8) {
                                        setTimeout(() => {
                                            document.getElementById('stepsite-numero')?.focus();
                                        }, 600);
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Logradouro" name="rua" rules={[{ required: true, message: 'Informe a rua!' }]}>
                            <Input placeholder="Nome da Rua" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Email do Responsável" name="emailResponsavel">
                            <Input placeholder="email@empresa.com" type="email" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="Número" name="numero" rules={[{ required: true, message: 'Informe o número!' }]}>
                            <Input
                                id="stepsite-numero"
                                placeholder="Nº"
                                onChange={(e) => onNumeroChange?.(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Bairro" name="bairro" rules={[{ required: true, message: 'Informe o bairro!' }]}>
                            <Input placeholder="Bairro" />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Cidade" name="cidade" rules={[{ required: true, message: 'Informe a cidade!' }]}>
                            <Input placeholder="Cidade" />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Estado" name="estado" rules={[{ required: true, message: 'Informe o estado!' }]}>
                            <Input placeholder="UF" maxLength={2} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Status do Site" name="status" rules={[{ required: true, message: 'Selecione o status!' }]}>
                            <Select placeholder="Selecione o status">
                                <Option value="Conectado">Conectado</Option>
                                <Option value="Desconectado">Desconectado</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Latitude" name="latitude">
                            <Input placeholder="-23.550520" type="number" step="any" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Longitude" name="longitude">
                            <Input placeholder="-46.633308" type="number" step="any" />
                        </Form.Item>
                    </Col>
                </Row>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24, gap: 8 }}>
                    {currentStep > 0 && <Button onClick={onPrev}>Voltar</Button>}
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                        {currentStep < totalSteps - 1 && (
                            <Button
                                onClick={onNext}
                                disabled={!siteSalvo && !selectedSite}
                            >
                                Próximo
                            </Button>
                        )}
                        <Button type="primary" onClick={handleSave} loading={loading} style={{ backgroundColor: '#2957A4', borderColor: '#2957A4' }}>
                            Salvar
                        </Button>
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default StepSite;
